import React, { useEffect, useMemo, useState } from "react";

function normalizeTimeToHHmm(raw) {
  if (raw == null) return { ok: false, value: "", reason: "empty" };

  let s = String(raw).trim();
  if (!s) return { ok: false, value: "", reason: "empty" };

  // Allow separators ":" "." " " "-"
  s = s.replace(/[.\s-]/g, ":");

  // If user types 4 digits like "1930" => "19:30"
  if (/^\d{3,4}$/.test(s) && !s.includes(":")) {
    s = s.padStart(4, "0"); // "930" -> "0930"
    s = `${s.slice(0, 2)}:${s.slice(2, 4)}`;
  }

  // If user types "10:" or "10:0" normalize minutes
  const m = s.match(/^(\d{1,2})(?::(\d{0,2}))?$/);
  if (!m) return { ok: false, value: "", reason: "format" };

  const hh = m[1];
  const mm = m[2] ?? "";

  const h = Number(hh);
  if (!Number.isFinite(h) || h < 0 || h > 23) return { ok: false, value: "", reason: "hour" };


  let minutesStr = mm;
  if (minutesStr.length === 0) minutesStr = "00";
  if (minutesStr.length === 1) minutesStr = `${minutesStr}0`;

  const min = Number(minutesStr);
  if (!Number.isFinite(min) || min < 0 || min > 59) return { ok: false, value: "", reason: "minute" };

  const out = `${String(h).padStart(2, "0")}:${String(min).padStart(2, "0")}`;
  return { ok: true, value: out, reason: "" };
}

export default function TimeInput24h({
  value,
  onChange,
  className = "",
  placeholder = "HH:MM",
  disabled = false,
  readOnly = false,
  required = false,
  allowEmpty = true,
  showError = true,
  id,
  name,
}) {
  const [text, setText] = useState(value ?? "");
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState("");


  useEffect(() => {
    setText(value ?? "");
  }, [value]);

  const commit = () => {
    const trimmed = (text ?? "").trim();

    if (!trimmed) {
      setError(required && !allowEmpty ? "Ora este obligatorie" : "");
      if (allowEmpty && onChange) onChange("");
      return;
    }

    const res = normalizeTimeToHHmm(trimmed);
    if (!res.ok) {
      setError("Ora invalidă. Exemplu: 09:30, 16:00, 19:20");
      return;
    }

    setError("");
    setText(res.value);
    if (onChange) onChange(res.value);
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      commit();
    }
    if (e.key === "Escape") {
      e.preventDefault();
      setText(value ?? "");
      setError("");
    }
  };

  const hint = useMemo(() => {
    if (!showError || !touched || !error) return null;
    return <div className="error" style={{ marginTop: 6 }}>⚠️ {error}</div>;
  }, [showError, touched, error]);

  return (
    <div>
      <input
        id={id}
        name={name}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        className={className}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        value={text}
        onChange={(e) => {
          setText(e.target.value);
          if (touched) setError(""); 
        }}
        onBlur={() => {
          setTouched(true);
          commit();
        }}
        onKeyDown={onKeyDown}
      />
      {hint}
    </div>
  );
}